import { render, staticRenderFns } from "./ItGoals.vue?vue&type=template&id=74fd5817&scoped=true&"
import script from "./ItGoals.vue?vue&type=script&lang=js&"
export * from "./ItGoals.vue?vue&type=script&lang=js&"
import style0 from "./ItGoals.vue?vue&type=style&index=0&id=74fd5817&scoped=true&lang=scss&"
import style1 from "./ItGoals.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd5817",
  null
  
)

export default component.exports